
// import axios from 'axios'

const state = {
  loading: false,
  refCount: 0,
  dialogInfo: { 'active': false, 'text': '' },
  clearing: false,
  openFile: false,
  visible: false,
  title: '',
  message: '',
  type: 'error', // 'error' | 'warning' | 'info' | 'success'
  activeBattery: {
    'c1': true,
    'c2': true,
    'c3': true,
    'c4': true,
    'c5': true,
    'c6': true
  },
  // selected_input: { 'value': '' },
  config: {
    QUIESCENT_MODE_ARRAY: ['6', '24', '72'],
    QUIESCENT_MODE: 24, // INFO F17
    EVACUATION_TIME: 30, // INFO F19
    SAFETY_FACTOR: 30
  },
  clusters: {},
  clusterOne: {
    powerSupply: {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0},
    output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
    output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
    noiseSensor: {poePorts: 0},
    interfaceControl: {poePorts: 0},
    interfaceAudio: {poePorts: 0},
    panelControl: {poePorts: 0}
  },
  clusterTwo: {
    powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
    output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
    output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
    noiseSensor: {poePorts: 0},
    interfaceControl: {poePorts: 0},
    interfaceAudio: {poePorts: 0},
    panelControl: {poePorts: 0}
  },
  clusterThree: {
    powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
    output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
    output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
    noiseSensor: {poePorts: 0},
    interfaceControl: {poePorts: 0},
    interfaceAudio: {poePorts: 0},
    panelControl: {poePorts: 0}
  },
  clusterFour: {
    powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
    output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
    output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
    noiseSensor: {poePorts: 0},
    interfaceControl: {poePorts: 0},
    interfaceAudio: {poePorts: 0},
    panelControl: {poePorts: 0}
  },
  clusterFive: {
    powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
    output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
    output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
    noiseSensor: {poePorts: 0},
    interfaceControl: {poePorts: 0},
    interfaceAudio: {poePorts: 0},
    panelControl: {poePorts: 0}
  },
  clusterSix: {
    powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
    output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
    output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
    callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
    noiseSensor: {poePorts: 0},
    interfaceControl: {poePorts: 0},
    interfaceAudio: {poePorts: 0},
    panelControl: {poePorts: 0}
  },
  inputs: {
    czas_podtrzymania: { 'value': 24 },
    czas_alarmowania: { 'value': 0.5 },
    dodatkowe_u: { 'value': 0, 'min': 0, 'max': 50 },
    glebokosc: {'value': ['600']},
    glebokosc_szafy: {'value': 600, 'active': false},
    sieciowanie_systemu: { 'value': 'nie' },
    tryb_poboru_mocy: { 'value': 'standby' },
    // kolka: { 'value': 0, 'min': 0, 'max': 1 },
    kolka: { 'value': 0 },
    szafa_drzwi: { 'value': 1 },
    polka_mikrofon: { 'value': 0 },
    panel_wentylacyjny: { 'value': 1, 'min': 0, 'max': 1 },
    wariant2: { 'value': 0, 'min': 0, 'max': 16 },
    wariant2_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    wariant3: { 'value': 0, 'min': 0, 'max': 16 },
    wariant3_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 },
    sterownik: {'value': ''},
    przylacze_zasilania: {'value': '', 'active': false}
    // csDesktop: { 'value': 0, 'min': 0, 'max': 2 },
    // csWall: { 'value': 0, 'min': 0, 'max': 2 },
    // csExt: { 'value': 0, 'min': 0, 'max': 0 },
    // poePorts: { 'value': 0, 'min': 0, 'max': 0 },
    // cstEmergency: { 'value': 0, 'min': 0, 'max': 0 }
  },
  outputs: {
    cena: {
      'szafa': 0,
      'akumulatory': 0,
      'listwaD': 0,
      'listwaZ': 0,
      'panelS': 0,
      'panelW': 0,
      'polka': 0,
      'kolka': 0,
      'zasilacz_dsos24_pra': 0,
      'obudowa_dsos24': 0,
      'obudowa_plytki': 0,
      'inne': 0,
      'total': 0
    },
    waga: {
      'szafa': 0,
      'akumulatory': 0,
      'listwaD': 0,
      'listwaZ': 0,
      'panelS': 0,
      'panelW': 0,
      'polka': 0,
      'kolka': 0,
      'zasilacz_dsos24_pra': 0,
      'obudowa_dsos24': 0,
      'obudowa_plytki': 0,
      'inne': 0,
      'total': 0
    },
    szafa: {
      kod: '',
      nazwa: '',
      id: '',
      gen_code: '',
      attributes: {
        wysokosc: '',
        mm: '',
        szerokosc: '',
        glebokosc: '',
        cena: '',
        waga: ''
      }
    },
    akumulator: {
      kod: '',
      nazwa: '',
      gen_code: '',
      pojemnosc: '',
      ilosc: '',
      polki: '',
      wysokosc: '',
      waga: '',
      cena: '',
      prad: ''
    },
    akumulator_user: {
      c1: false,
      c2: false,
      c3: false,
      c4: false,
      c5: false,
      c6: false
    },
    akumulators: {},
    akumulators_buffor: {},
    mozliwe_akumulatory: {},
    qtyClusters: {'value': 0},
    resultDevices: {},
    resultLoss: {},
    szafa_wolne_miejsce: { 'value': 0 },
    wysokosc_urzadzen: { 'value': [] },
    szafa_zajete_miejsce: { 'value': 0 },
    keyGen: { 'value': '' },
    rabat: { 'value': 0 },

    zamawiajacy: {
      nazwa: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: '',
      email: '',
      nip: ''
    },
    inwestycja: {
      nazwa: '',
      // biuro_projektant: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: '',
      email: ''
    },
    wysylka: {
      nazwa: '',
      imie_nazwisko: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: ''
    }
  },
  errors: {
    'brak_miejsca': false,
    'brak_szafy': false,
    'brak_akumulatora': false
  },
  copyValues: {}
}

const getters = {
  // selected_input: state => state.selected_input
  loading: state => state.loading,
  refCount: state => state.refCount,
  clearing: state => state.clearing,
  openFile: state => state.openFile,
  inputs: state => state.inputs,
  outputs: state => state.outputs,
  config: state => state.config,
  errors: state => state.errors,
  copyValues: state => state.copyValues,
  dialogInfo: state => state.dialogInfo,
  clusters: state => state.clusters,
  clusterOne: state => state.clusterOne,
  clusterTwo: state => state.clusterTwo,
  clusterThree: state => state.clusterThree,
  clusterFour: state => state.clusterFour,
  clusterFive: state => state.clusterFive,
  clusterSix: state => state.clusterSix
}

const mutations = {
  SET_LOADING (state, loading) {
    if (loading) {
      state.refCount++
      state.loading = loading
    } else {
      state.refCount--
      state.loading = loading
    }
    state.loading = state.refCount !== 0
  },

  SET_DIALOG_INFO (state, payload) {
    state.dialogInfo.active = payload.active
    state.dialogInfo.text = payload.text
  },

  SET_ERROR_INFO (state, payload) {
    state.errors[payload[0]] = payload[1]
  },
  SET_COPY_VALUES (state, payload) {
    state.copyValues = payload
  },

  UPDATED_CLUSTER (state, payload) {
    state.clearing = false
    state.openFile = false
    // state.akumulator_user.value = false
    if (payload[0] === 'cluster1') {
      state.clusterOne = JSON.parse(JSON.stringify(payload[1]))
      // console.log(state.clusterOne)
      if (!state.clusterOne.powerSupply || state.clusterOne.powerSupply.selected === '-') {
        state.clusterOne.powerSupply = {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0}
      }
    }
    if (payload[0] === 'cluster2') {
      state.clusterTwo = JSON.parse(JSON.stringify(payload[1]))
      if (!state.clusterTwo.powerSupply || state.clusterTwo.powerSupply.selected === '-') {
        state.clusterTwo.powerSupply = {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0}
      }
    }
    if (payload[0] === 'cluster3') {
      state.clusterThree = JSON.parse(JSON.stringify(payload[1]))
      if (!state.clusterThree.powerSupply || state.clusterThree.powerSupply.selected === '-') {
        state.clusterThree.powerSupply = {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0}
      }
    }
    if (payload[0] === 'cluster4') {
      state.clusterFour = JSON.parse(JSON.stringify(payload[1]))
      if (!state.clusterFour.powerSupply || state.clusterFour.powerSupply.selected === '-') {
        state.clusterFour.powerSupply = {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0}
      }
    }
    if (payload[0] === 'cluster5') {
      state.clusterFive = JSON.parse(JSON.stringify(payload[1]))
      if (!state.clusterFive.powerSupply || state.clusterFive.powerSupply.selected === '-') {
        state.clusterFive.powerSupply = {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0}
      }
    }
    if (payload[0] === 'cluster6') {
      state.clusterSix = JSON.parse(JSON.stringify(payload[1]))
      if (!state.clusterSix.powerSupply || state.clusterSix.powerSupply.selected === '-') {
        state.clusterSix.powerSupply = {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0}
      }
    }
  },
  UPDATE_DATA_FILE (state, payload) {
    state.clearing = false
    // state.openFile = false
    var aKeys = {}
    var bKeys = {}
    var errorOpenFile = false

    aKeys = Object.keys(state.clusterOne).sort()
    bKeys = Object.keys(payload.clusterOne).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.clusterTwo).sort()
    bKeys = Object.keys(payload.clusterTwo).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.clusterThree).sort()
    bKeys = Object.keys(payload.clusterThree).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.clusterFour).sort()
    bKeys = Object.keys(payload.clusterFour).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.clusterFive).sort()
    bKeys = Object.keys(payload.clusterFive).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.clusterSix).sort()
    bKeys = Object.keys(payload.clusterSix).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.config).sort()
    bKeys = Object.keys(payload.config).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.inputs).sort()
    bKeys = Object.keys(payload.inputs).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    aKeys = Object.keys(state.outputs).sort()
    bKeys = Object.keys(payload.outputs).sort()
    if (!(JSON.stringify(aKeys) === JSON.stringify(bKeys))) {
      errorOpenFile = true
    }

    if (!errorOpenFile) {
      state.clusterOne = JSON.parse(JSON.stringify(payload.clusterOne))
      state.clusterTwo = JSON.parse(JSON.stringify(payload.clusterTwo))
      state.clusterThree = JSON.parse(JSON.stringify(payload.clusterThree))
      state.clusterFour = JSON.parse(JSON.stringify(payload.clusterFour))
      state.clusterFive = JSON.parse(JSON.stringify(payload.clusterFive))
      state.clusterSix = JSON.parse(JSON.stringify(payload.clusterSix))
      state.config = JSON.parse(JSON.stringify(payload.config))
      state.inputs = JSON.parse(JSON.stringify(payload.inputs))
      state.outputs = JSON.parse(JSON.stringify(payload.outputs))
      // state.outputs.szafa = {
      //   kod: '',
      //   nazwa: '',
      //   id: '',
      //   gen_code: '',
      //   attributes: {
      //     wysokosc: '',
      //     mm: '',
      //     szerokosc: '',
      //     glebokosc: '',
      //     cena: '',
      //     waga: ''
      //   }
      // }
    } else {
      // alert('UWAGA!\nPlik nie zgodny z obecną wersją.\nKonfiguracja została wczytana ale proszę sprawdzić konfigurację.\n\nZa utrudnienia przepraszamy.')
      this.dispatch('app/showInfo', { message: '<b style="font-size: 25px;">Wczytany plik jest niezgodny<br>z aktualną wersją systemu.</b><br><br>Konfiguracja została zaimportowana, lecz niektóre urządzenia lub ich ustawienia mogły ulec zmianie.<br>Prosimy o weryfikację bieżącej konfiguracji. <br><br>Przepraszamy za ewentualne niedogodności.' }, { root: true })

      state.clusterOne = JSON.parse(JSON.stringify(payload.clusterOne))
      state.clusterTwo = JSON.parse(JSON.stringify(payload.clusterTwo))
      state.clusterThree = JSON.parse(JSON.stringify(payload.clusterThree))
      state.clusterFour = JSON.parse(JSON.stringify(payload.clusterFour))
      state.clusterFive = JSON.parse(JSON.stringify(payload.clusterFive))
      state.clusterSix = JSON.parse(JSON.stringify(payload.clusterSix))
      state.config = JSON.parse(JSON.stringify(payload.config))
      state.inputs = JSON.parse(JSON.stringify(payload.inputs))
    }
  },

  SET_USER_ERROR (state, error) {
    state.error = error
  },

  UPDATE_VARIABLES (state, payload) {
    state[payload['name']] = payload['value']
  },

  UPDATE_CLUSTERS_SELECTED (state, payload) {
    state.clusters = payload
  },

  UPDATE_CLEARING (state, payload) {
    state.clearing = payload
  },

  SET_CONFIG (state, payload) {
    // state.config = payload
  },

  UPDATED_SELECTED_INPUT (state, payload) {
    // state.selected_input = payload
  },
  UPDATED_SELECTED_CONFIG (state, payload) {
    // state.config[payload[0]] = payload[1]
  },

  UPDATED_INPUTS (state, payload) {
    state.clearing = false
    // state.openFile = false
    if (state.inputs[payload['name']]) {
      if (payload.type === 'value') {
        state.inputs[payload['name']]['value'] = payload['val']
      }
      if (payload.type === 'min') {
        state.inputs[payload['name']]['min'] = payload['val']
      }
      if (payload.type === 'max') {
        state.inputs[payload['name']]['max'] = payload['val']
      }
      if (payload.type === 'active') {
        state.inputs[payload['name']]['active'] = payload['val']
      }
    }
  },

  UPDATED_OUTPUTS (state, payload) {
    state.clearing = false
    // state.openFile = false
    if (Array.isArray(payload['name'])) {
      state.outputs[payload['name'][0]][payload['name'][1]] = payload['val']
    }
    if (state.outputs[payload['name']]) {
      if (payload.type === 'value') {
        state.outputs[payload['name']]['value'] = payload['val']
      }
      if (payload.type === 'min') {
        state.outputs[payload['name']]['min'] = payload['val']
      }
      if (payload.type === 'max') {
        state.outputs[payload['name']]['max'] = payload['val']
      }
      if (payload.type === 'array') {
        state.outputs[payload['name']] = payload['val']
      }
    }
  },

  UPDATED_PRICE (state, payload) {
    state.outputs.cena[payload['name']] = payload['val']
    var suma = 0
    Object.keys(state.outputs.cena).forEach(element => {
      if (element !== 'total') {
        suma += Math.round(Number(state.outputs.cena[element]))
      }
    })
    state.outputs.cena.total = suma + 1
  },
  UPDATED_WEIGHT (state, payload) {
    state.outputs.waga[payload['name']] = payload['val']
    var suma = 0
    Object.keys(state.outputs.waga).forEach(element => {
      if (element !== 'total') {
        suma += Math.ceil(Number(state.outputs.waga[element]))
      }
    })
    state.outputs.waga.total = suma
  },

  SET_RESULT_DEVICE (state, payload) {
    state.outputs.resultDevices[payload[0]].required = payload[1]
  },

  SET_ACTIVE_BATTERY (state, payload) {
    state.activeBattery[payload[0]] = payload[1]
  },

  UPDATED_CONFIG (state, payload) {
    // if (payload.type === 'value') {
    //   state.config[payload['name']]['value'] = payload['val']
    // }
  },
  UPDATE_CLUSTER (state, { clusterIndex, partial }) {
    const key = `cluster${clusterIndex}` // 'clusterOne', 'clusterTwo', ...
    state[key] = {
      ...state[key],
      ...partial
    }
  },

  CLEAR_INPUTS (state) {
    state.inputs = {
    //   czas_podtrzymania: { 'value': 24 },
    //   czas_alarmowania: { 'value': 0.5 },
    //   dodatkowe_u: { 'value': 0, 'min': 0, 'max': 50 },
    //   glebokosc_szafy: { 'value': 600, 'active': false },
    //   sieciowanie_systemu: { 'value': 'nie' },
    //   tryb_poboru_mocy: { 'value': 'standby' },

    //   wzmacniacz: { 'value': 0, 'min': 0, 'max': 9 },
    //   wzmacniacz_rezerwowy: { 'value': 0, 'min': 0, 'max': 9 },
    //   kontroler: { 'value': 0, 'min': 0, 'max': 1 },
    //   router: { 'value': 0, 'min': 0, 'max': 6 },

    //   wariant1: { 'value': 0, 'min': 0, 'max': 1 },
    //   wariant1_rozszerzenia: { 'value': 0, 'min': 0, 'max': 1 },
    //   wariant2: { 'value': 0, 'min': 0, 'max': 16 },
    //   wariant2_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    //   wariant3: { 'value': 0, 'min': 0, 'max': 16 },
    //   wariant3_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    //   wariant4: { 'value': 0, 'min': 0, 'max': 16 },
    //   wariant4_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    //   // wariant5: { 'value': 0, 'min': 0, 'max': 16 },
    //   // wariant5_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },

    //   obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 },
    //   panel_wentylacyjny: { 'value': 0, 'min': 0, 'max': 1 },
      kolka: { 'value': 0, 'min': 0, 'max': 1 },
      obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 },
      polka_mikrofon: { 'value': 0 }
      // csDesktop: { 'value': 0, 'min': 0, 'max': 2 },
      // csWall: { 'value': 0, 'min': 0, 'max': 2 },
      // csExt: { 'value': 0, 'min': 0, 'max': 0 },
      // poePorts: { 'value': 0, 'min': 0, 'max': 0 },
      // cstEmergency: { 'value': 0, 'min': 0, 'max': 0 }

    //   sygnal_pilota_cb: { 'value': false },
    //   sygnal_pilota: { 'value': 0, 'min': 0, 'max': 9000 },
    //   moc_glosnikow: { 'value': 0, 'min': 0, 'max': 9000 },
    //   moc_systemu: { 'value': 0 }
    }
  },
  CLEAR_CLUSTERS (state) {
    state.clearing = true
    state.openFile = false
    state.clusters = {}
    state.clusterOne = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    state.clusterTwo = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    state.clusterThree = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    state.clusterFour = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    state.clusterFive = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    state.clusterSix = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    state.outputs.akumulators = {}
    state.outputs.resultDevices = {}
    state.outputs.resultLoss = {}
    state.outputs.szafa = {
      kod: '',
      nazwa: '',
      id: '',
      gen_code: '',
      attributes: {
        wysokosc: '',
        mm: '',
        szerokosc: '',
        glebokosc: '',
        cena: '',
        waga: ''
      }
    }
    state.inputs.dodatkowe_u = { 'value': 0, 'min': 0, 'max': 50 }
    state.inputs.glebokosc = {'value': ['600']}
    state.inputs.glebokosc_szafy = {'value': 600, 'active': false}
    state.inputs.kolka = { 'value': 0 }
    state.inputs.obudowa_plytki = { 'value': 0, 'min': 0, 'max': 1000 }
    state.inputs.szafa_drzwi = { 'value': 1 }
    state.inputs.polka_mikrofon = { 'value': 0 }
    state.inputs.panel_wentylacyjny = { 'value': 1, 'min': 0, 'max': 1 }
    state.inputs.wariant2 = { 'value': 0, 'min': 0, 'max': 16 }
    state.inputs.wariant2_rozszerzenia = { 'value': 0, 'min': 0, 'max': 32 }
    state.inputs.wariant3 = { 'value': 0, 'min': 0, 'max': 16 }
    state.inputs.wariant3_rozszerzenia = { 'value': 0, 'min': 0, 'max': 32 }
    state.inputs.sterownik = {'value': ''}
    state.inputs.przylacze_zasilania = {'value': ''}
    // state.inputs.csDesktop = { 'value': 0, 'min': 0, 'max': 2 }
    // state.inputs.csWall = { 'value': 0, 'min': 0, 'max': 2 }
    // state.inputs.csExt = { 'value': 0, 'min': 0, 'max': 0 }
    // state.inputs.poePorts = { 'value': 0, 'min': 0, 'max': 0 }
    // state.inputs.cstEmergency = { 'value': 0, 'min': 0, 'max': 0 }

    state.outputs.cena = {
      'szafa': 0,
      'akumulatory': 0,
      'listwaD': 0,
      'listwaZ': 0,
      'panelS': 0,
      'panelW': 0,
      'polka': 0,
      'kolka': 0,
      'zasilacz_dsos24_pra': 0,
      'obudowa_dsos24': 0,
      'obudowa_plytki': 0,
      'inne': 0,
      'total': 0
    }
    state.outputs.qtyClusters = {'value': 0}
    state.outputs.akumulators = {}
    state.outputs.akumulators_buffor = {}

    state.outputs.mozliwe_akumulatory = {}
    state.outputs.akumulator_user = {
      c1: false,
      c2: false,
      c3: false,
      c4: false,
      c5: false,
      c6: false
    }
    state.outputs.szafa_wolne_miejsce = { 'value': 0 }
    state.outputs.szafa_zajete_miejsce = { 'value': 0 }
    state.outputs.wysokosc_urzadzen = { 'value': [] }
    state.outputs.keyGen = {'value': ''}
    state.outputs.rabat = { 'value': 0 }
  },
  CLEAR_CLUSTER (state, payload) {
    var str = ''
    if (payload === 1) { str = 'One' }
    if (payload === 2) { str = 'Two' }
    if (payload === 3) { str = 'Three' }
    if (payload === 4) { str = 'Four' }
    if (payload === 5) { str = 'Five' }
    if (payload === 6) { str = 'Six' }

    state['cluster' + str] = {
      powerSupply: {'selected': '-', ethernet: 0, sfp: 0},
      output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
      output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
      callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
      noiseSensor: {poePorts: 0},
      interfaceControl: {poePorts: 0},
      interfaceAudio: {poePorts: 0},
      panelControl: {poePorts: 0}
    }
    if (state.clusters['cluster' + payload]) {
      state.clusters['cluster' + payload] = []
    }
    if (state.outputs.akumulators['c' + payload]) {
      state.outputs.akumulators['c' + payload] = null
    }
    if (state.outputs.resultDevices['c' + payload]) {
      state.outputs.resultDevices['c' + payload] = null
    }
  },
  CLEAR_ADDRESS (state) {
    state.outputs.zamawiajacy = {
      nazwa: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: '',
      email: '',
      nip: ''
    }
    state.outputs.inwestycja = {
      nazwa: '',
      // biuro_projektant: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: '',
      email: ''
    }
    state.outputs.wysylka = {
      nazwa: '',
      imie_nazwisko: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: ''
    }
  },
  SHOW_DIALOG (state, { title, message, type = 'error' }) {
    state.visible = true
    state.title = title
    state.message = message
    state.type = type
  },
  HIDE_DIALOG (state) {
    state.visible = false
    state.title = ''
    state.message = ''
  }
}

const actions = {
  showError ({ commit }, { title = 'Błąd', message }) {
    commit('SHOW_DIALOG', { title, message, type: 'error' })
  },
  showInfo ({ commit }, { title = 'Informacja', message }) {
    commit('SHOW_DIALOG', { title, message, type: 'info' })
  },
  showSuccess ({ commit }, { title = 'Sukces', message }) {
    commit('SHOW_DIALOG', { title, message, type: 'success' })
  },
  hideDialog ({ commit }) {
    commit('HIDE_DIALOG')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js